export default __webpack_public_path__ + "static/media/pencil-dark.595625e4.svg";